import { Compass, Heart, Briefcase, Sparkles, Mountain, Waves } from "lucide-react";

export const PURPOSES = [
  { key: "healing",              label: "Healing",             icon: Waves },
  { key: "love",                 label: "Love",                icon: Heart },
  { key: "career inspiration",   label: "Career Inspiration",  icon: Briefcase },
  { key: "spiritual awakening",  label: "Spiritual Awakening", icon: Sparkles },
  { key: "adventure",            label: "Adventure",           icon: Compass },
  { key: "relaxation",           label: "Relaxation",          icon: Mountain },
];
export const BUDGETS = [
  { key: "under_1500",  label: "Under $1,500" },
  { key: "1500_3000",   label: "$1,500 – $3,000" },
  { key: "3000_5000",   label: "$3,000 – $5,000" },
  { key: "luxury_5000", label: "Luxury ($5,000+)" },
];
export const TIMINGS = [
  { key: "3_months",  label: "Within 3 months" },
  { key: "6_months",  label: "3 – 6 months" },
  { key: "12_months", label: "6 – 12 months" },
];
export const STYLES = [
  { key: "solo",    label: "Solo" },
  { key: "couple",  label: "Couple" },
  { key: "friends", label: "Friends" },
  { key: "group",   label: "Group Retreat" },
];
export const EXPERIENCES = [
  { key: "beach",           label: "Beach" },
  { key: "mountains",       label: "Mountains" },
  { key: "nature",          label: "Nature" },
  { key: "culture",         label: "Culture" },
  { key: "luxury_resort",   label: "Luxury Resort" },
  { key: "meditation",      label: "Meditation Retreat" },
];

export const STEPS = [
  { field: "purpose",    label: "What are you seeking?",            options: PURPOSES },
  { field: "budget",     label: "What investment feels comfortable?", options: BUDGETS },
  { field: "timing",     label: "When would you like to travel?",     options: TIMINGS },
  { field: "style",      label: "Travel style",                       options: STYLES },
  { field: "experience", label: "Experience preference",              options: EXPERIENCES },
];
